<template>
  <div>
    <template v-if="kategori === 'cv'">
      <v-expansion-panels tile flat>
        <v-expansion-panel v-for="cv in keys[fungsi]" :key="cv.id">
          <v-expansion-panel-header class="px-4 subtitle-1">
            <b>{{ listCv[cv]['title'] }}</b>
          </v-expansion-panel-header>
          <v-divider></v-divider>
          <v-expansion-panel-content class="px-0">
            <base-list-info v-if="['dasar', 'pa', 'tambahan'].includes(cv)" :info="info[cv]" />
            <template v-else-if="cv === 'dokumen'">
              <div
                v-if="
                  $getDeepObj(initValue, `${listCv[cv]['model']}.data`) &&
                    $getDeepObj(initValue, `${listCv[cv]['model']}.data`).length
                "
              >
                <v-row v-for="(item, i) in listBerkases" :key="i" class="my-2">
                  <v-col cols="12" md="10" sm="12" class="py-0">
                    <div class="black--text">
                      {{ $getDeepObj(item, 'm_profil_berkas_psp.data.keterangan') || '' }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="2" sm="12" class="pa-0">
                    <v-btn depressed small color="blue mr-2" dark @click="onView(item)">
                      <v-icon left class="body-1 mr-1">mdi-eye</v-icon> Lihat
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="12" sm="12">
                    <v-divider />
                  </v-col>
                </v-row>
              </div>
              <div v-else class="text-center my-2 red--text">
                <b>Data Tidak Ditemukan</b>
              </div>
            </template>
            <template v-else>
              <div
                v-if="
                  $getDeepObj(initValue, `${listCv[cv]['model']}.data`) &&
                    $getDeepObj(initValue, `${listCv[cv]['model']}.data`).length
                "
              >
                <v-list-item
                  class="pa-0"
                  v-for="(item, i) in $getDeepObj(initValue, listCv[cv]['model'])['data']"
                  :key="i"
                >
                  <v-list-item-avatar class="mr-3" color="yellow" size="40">
                    <v-icon>{{ listCv[cv]['icon'] }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle class="mb-0 black--text">
                      {{ $getDeepObj(item, listCv[cv]['keterangan']) }}
                    </v-list-item-subtitle>
                    <template>
                      <span class="subtitle-1" style="line-height: 1.5rem"></span>
                      <span class="subtitle-1 grey--text text--darken-1" style="line-height: 1.5rem"> </span>
                    </template>
                  </v-list-item-content>
                </v-list-item>
              </div>
              <div v-else class="text-center my-2 red--text">
                <b>Data Tidak Ditemukan</b>
              </div>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <template v-else-if="kategori === 'sap'">
      <v-row class="black--text mt-2">
        <v-col v-for="(item, i) in infoSap" :key="i" v-bind="item.grid">
          <span :class="`label--text ${!item.label ? 'white--text' : ''}`">{{ item.label || '-' }}</span>
          <template v-if="item.type === 'divider'">
            <v-divider />
          </template>
          <template v-else-if="item.type === 'file'">
            <span class="label--text"></span>
            <v-list-item v-for="(child, c) in item.value || []" :key="c">
              <v-list-item-content class="blue--text body-2">
                {{ child.name }}
              </v-list-item-content>
              <v-list-item-action>
                <v-btn small depressed color="primary" :disabled="!child.value" @click="toLink(child.value)">
                  <v-icon left>mdi-eye</v-icon> Lihat
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
          <template v-else>
            <div class="body-2" v-html="item.value"></div>
          </template>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-expansion-panels accordion class="mt-5 elevation-0">
        <v-expansion-panel v-for="(pertanyaan, i) in pertanyaans" :key="i">
          <v-expansion-panel-header :id="`panels-id-${i + 1}`">
            <span class="indigo--text darken-4--text subtitle-1 font-weight-medium">
              {{ pertanyaan.title }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pa-2">
            <v-card outlined class="pa-0">
              <v-card-text class="pa-0">
                <v-expansion-panels accordion class="mt-2" flat>
                  <v-expansion-panel v-for="(sub, j) in getEsai(i + 1)" :key="sub.id">
                    <v-expansion-panel-header>
                      <v-row no-gutters dense class="black--text subtitle-1 font-weight-medium">
                        <v-col cols="1">
                          <div>{{ $getDeepObj(sub, 'kode') }}.</div>
                        </v-col>
                        <v-col cols="11" class="ml-md-n10">
                          {{ $getDeepObj(sub, 'pertanyaan') }}
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row no-gutters>
                        <v-col cols="12" md="1" sm="1"> &nbsp; </v-col>
                        <v-col cols="12" md="11" sm="11" class="ml-md-n10">
                          <span
                            v-html="
                              $stringToHtml(
                                $getDeepObj(resultEsai, `${sub.k_profil_esai_psp}.deskripsi`) || 'Belum di jawab'
                              )
                            "
                          ></span>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                    <v-divider v-if="getEsai(i + 1).length - 1 < j"></v-divider>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <popup-preview-detail
      ref="popup"
      :url="[undefined, '', null].includes(preview['url']) ? '' : preview['url']"
      :title="[undefined, '', null].includes(preview['title']) ? '' : preview['title']"
    />
  </div>
</template>
<script>
import PopupPreviewDetail from '@components/popup/PreviewDetil';
import BaseListInfo from '@components/base/BaseListInfo';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => {},
    },
    kategori: {
      type: String,
      default: 'cv',
    },
    pertanyaans: {
      type: Array,
      default: () => [],
    },
    isAsesor: {
      type: Boolean,
      default: false,
    },
  },
  components: { PopupPreviewDetail, BaseListInfo },
  data() {
    return {
      preview: {},
      keys: {
        kasek: ['dasar', 'diklat', 'organisasi', 'program', 'prestasi', 'komunitas', 'hobi', 'dokumen'],
        instruktur: ['pa', 'bimbingan', 'organisasi_pa', 'diklat', 'prestasi', 'hobi', 'tambahan', 'dokumen'],
      },
    };
  },
  computed: {
    resultEsai() {
      return this.$arrToObj(this.initValue.psp_profil_esais.data, 'k_profil_esai_psp');
    },

    fungsi() {
      return Number(this.initValue?.k_profil_psp) === 1 ? 'instruktur' : 'kasek';
    },

    profil() {
      return this.initValue || {};
    },

    listCv() {
      const content = {
        kasek: {
          dasar: {
            component: 'Info',
            form: 'FormInput',
            title: 'Informasi Umum',
            status: 'profil',
            optional: false,
          },
          diklat: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Pengalaman Mengikuti Pelatihan',
            status: 'diklat',
            deskripsi:
              'Tuliskan maksimal 10 (sepuluh) pelatihan yang relevan dengan profesi anda yang pernah anda ikuti selama 3 tahun terakhir',
            max: 10,
            model: 'psp_profil_diklats',
            keterangan: 'pelatihan',
            icon: 'mdi-google-classroom',
            optional: true,
          },
          organisasi: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Pengalaman Berorganisasi',
            status: 'organisasi',
            deskripsi: 'Tuliskan maksimal 5 (lima) pengalaman berorganisasi Anda',
            max: 5,
            model: 'psp_profil_organisasis',
            keterangan: 'organisasi',
            icon: 'mdi-account-group',
            optional: true,
          },
          program: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Pengalaman Menjalankan Program Linstas Instansi',
            status: 'program',
            deskripsi:
              'Tuliskan maksimal 5 (lima) pengalaman Anda menjalankan program/ kerja sama antara Satuan Pendidikan yang Anda pimpin dengan instansi/ organisasi lain dalam 4 tahun terakhir',
            max: 5,
            model: 'psp_profil_programs',
            keterangan: 'm_profil_opsi_psp_program_instansi.data.keterangan',
            icon: 'mdi-clipboard-text',
            optional: true,
          },
          prestasi: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Prestasi',
            status: 'prestasi',
            deskripsi:
              'Tuliskan pengalaman prestasi yang pernah Anda (bukan prestasi Satuan Pendidikan yang Anda Pimpin) raih dalam kurun waktu 5 tahun terakhir',
            max: 5,
            model: 'psp_profil_prestasis',
            keterangan: 'prestasi',
            icon: 'mdi-trophy',
            optional: true,
          },
          komunitas: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Keterlibatan Dalam Kegiatan Komunitas Masyarakat',
            status: 'komunitas',
            deskripsi:
              'Tuliskan maksimal 5 (lima) keterlibatan Anda dalam kegiatan komunitas masyarakat yang Anda ikuti dalam kurun waktu 3 tahun terakhir',
            max: 5,
            model: 'psp_profil_komunitases',
            keterangan: 'kegiatan',
            icon: 'mdi-account-group',
            optional: true,
          },
          hobi: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Hobi',
            status: 'hobi',
            deskripsi: 'Tuliskan hobi yang Anda tekuni dalam mengisi waktu luang',
            max: 5,
            model: 'psp_profil_hobis',
            keterangan: 'hobi',
            icon: 'mdi-book',
            optional: true,
          },
          dokumen: {
            component: 'Daftar',
            form: 'FormUnggah',
            title: 'Dokumen Penting',
            status: 'berkas',
            deskripsi: '',
            model: 'psp_profil_berkases',
            optional: false,
          },
        },
        instruktur: {
          pa: {
            component: 'Info',
            form: 'FormInput',
            title: 'Informasi Umum',
            status: 'profil',
            optional: false,
          },
          bimbingan: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Pengalaman Melakukan Pendampingan & Pembimbingan',
            status: 'bimbingan',
            deskripsi: 'Tuliskan pengalaman melakukan pendampingan/pembimbingan yang pernah anda lakukan.',
            max: 10,
            optional: true,
            model: 'psp_profil_programs',
            keterangan: 'program',
            icon: 'mdi-teach',
          },
          organisasi_pa: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Pengalaman Berorganisasi',
            status: 'organisasi',
            deskripsi: 'Tuliskan maksimal 5 (lima) pengalaman berorganisasi Anda',
            max: 5,
            optional: true,
            model: 'psp_profil_organisasis',
            keterangan: 'organisasi',
            icon: 'mdi-briefcase',
          },
          diklat: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Pengalaman Mengikuti Pelatihan Pelaksanaan Pendampingan',
            status: 'diklat',
            deskripsi:
              'Tuliskan maksimal 10 (sepuluh) pelatihan pelaksanaan pendampingan/pembimbingan peningkatan mutu pendidikan yang pernah Anda ikuti.',
            max: 10,
            optional: true,
            model: 'psp_profil_diklats',
            keterangan: 'pelatihan',
            icon: 'mdi-google-classroom',
          },
          prestasi: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Prestasi',
            status: 'prestasi',
            deskripsi: 'Tuliskan pengalaman prestasi yang pernah Anda raih dalam kurun waktu 5 tahun terakhir',
            max: 10,
            optional: true,
            model: 'psp_profil_prestasis',
            keterangan: 'prestasi',
            icon: 'mdi-trophy',
          },
          hobi: {
            component: 'Daftar',
            form: 'FormCollection',
            title: 'Hobi',
            status: 'hobi',
            deskripsi: 'Tuliskan hobi yang Anda tekuni dalam mengisi waktu luang',
            max: 5,
            optional: true,
            model: 'psp_profil_hobis',
            keterangan: 'hobi',
            icon: 'mdi-book',
          },
          tambahan: {
            component: 'Info',
            form: 'FormInput',
            title: 'Pertanyaan Tambahan',
            status: 'tambahan',
            optional: false,
          },
          dokumen: {
            component: 'Daftar',
            form: 'FormUnggah',
            title: 'Dokumen Penting',
            status: 'berkas',
            deskripsi: '',
            optional: false,
            model: 'psp_profil_berkases',
          },
        },
      };

      return content[this.fungsi];
    },

    infoSap() {
      const item = this.$getDeepObj(this, 'profil.psp_profil_sap.data') || {};
      return [
        {
          key: 'nama',
          label: '',
          value: `<span class='font-weight-medium'>Detail SAP (Satuan Acara Pelatihan)</span>`,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          key: 'ptk_id',
          label: 'No Ukg',
          value: this.$getDeepObj(this.profil, 'ptk.data.no_ukg') || '-',
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          key: 'divider',
          type: 'divider',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'pelatihan',
          label: 'Nama Pelatihan',
          value: this.$getDeepObj(item, 'judul') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'diklat',
          label: 'Nama Mata Diklat',
          value: this.$getDeepObj(item, 'm_topik_sap_psp.data.keterangan') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'tujuan',
          label: 'Tujuan Pelatihan',
          value: this.$getDeepObj(item, 'tujuan') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'indikator',
          label: 'Indikator Pelatihan',
          value: this.$getDeepObj(item, 'indikator') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'pendahuluan',
          label: 'A. Pendahuluan (alokasi waktu 2 menit)',
          value: this.$getDeepObj(item, 'pendahuluan') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'inti',
          label: 'B. Kegiatan Inti (alokasi waktu 6 menit)',
          value: this.$getDeepObj(item, 'kegiatan') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'penutup',
          label: 'C. Penutup (alokasi waktu 2 menit)',
          value: this.$getDeepObj(item, 'penutup') || '-',
          grid: { cols: 12, md: 12, sm: 12 },
        },
        {
          key: 'berkas',
          label: 'Berkas SAP',
          type: 'file',
          value: [
            {
              name: 'Dokumen Satuan Acara Pelatihan (PDF)',
              value: this.$getDeepObj(item, 'url_sap') || null,
            },
          ],
          grid: { cols: 12, md: 12, sm: 12 },
        },
      ];
    },

    info() {
      const kUnsurPsp = this.$getDeepObj(this.profil, 'k_unsur_psp') || null;
      const kKurikulumPsp = this.$getDeepObj(this.profil, 'k_kurikulum_psp') || null;
      const schemaPa = {
        dasar: [
          [
            {
              key: 'nama',
              label: 'Nama',
              value: this.$getDeepObj(this.profil, 'ptk.data.nama') || '-',
            },
            {
              key: 'nik',
              label: 'NIK (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'nik') || '-',
            },
          ],
          [
            {
              key: 'tmp_lahir',
              label: 'Tempat Lahir',
              value: this.$getDeepObj(this.profil, 'ptk.data.tmp_lahir') || '-',
            },
            {
              key: 'tgl_lahir',
              label: 'Tanggal Lahir',
              value: this.$localDate(this.$getDeepObj(this.profil, 'ptk.data.tgl_lahir') || '-'),
            },
          ],
          [
            {
              key: 'usia',
              label: 'Usia',
              value: this.$getDeepObj(this.profil, 'usia') || '-',
            },
            {
              key: 'email',
              label: 'Alamat Surel',
              value: this.$getDeepObj(this.profil, 'ptk.data.email') || '-',
            },
          ],
          [
            {
              key: 'no_telpon',
              label: 'Nomor Telepon',
              value: this.$getDeepObj(this.profil, 'ptk.data.no_hp') || '-',
            },
            {
              key: 'no_wa',
              label: 'Nomor Telepon (terhubung WhatsApp)',
              value: this.$getDeepObj(this.profil, 'no_wa') || '-',
            },
          ],
          [
            {
              key: 'alamat_ktp',
              label: 'Alamat (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'alamat_ktp') || '-',
              size: 12,
            },
          ],
          [
            {
              key: 'k_propinsi_ktp',
              label: 'Provinsi (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'm_propinsi_ktp.data.keterangan') || '-',
            },
            {
              key: 'k_kota_ktp',
              label: 'Kota/Kabupaten (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'm_kota_ktp.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'alamat',
              label: 'Alamat Tinggal Sekarang',
              value: this.$getDeepObj(this.profil, 'alamat') || '-',
              size: 12,
            },
          ],
          [
            {
              key: 'k_propinsi',
              label: 'Provinsi',
              value: this.$getDeepObj(this.profil, 'm_propinsi.data.keterangan') || '-',
            },
            {
              key: 'k_kota',
              label: 'Kota/Kabupaten',
              value: this.$getDeepObj(this.profil, 'm_kota.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'kodepos',
              label: 'Kodepos',
              value: this.$getDeepObj(this.profil, 'kodepos') || '-',
            },
            {
              key: 'k_unsur_psp',
              label: 'Unsur Kandidat Fasilitator ',
              value: this.$getDeepObj(this.profil, 'm_unsur_psp.data.keterangan') || '-',
            },
          ],
        ],
        profesi: [
          [
            {
              key: 'profesi',
              label: 'Apa profesi/pekerjaan Anda saat ini',
              value: this.$getDeepObj(this.profil, 'profesi') || '-',
            },
          ],
        ],
        pendidikan: [
          [
            {
              key: 'k_kasek_sisa_psp',
              label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_pendampingan.data.keterangan') || '-',
            },
            {
              key: 'k_kualifikasi',
              label: 'Pendidikan terakhir',
              value: this.$getDeepObj(this.profil, 'm_kualifikasi.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'pendidikan_instansi',
              label: 'Nama instansi pendidikan terakhir',
              value: this.$getDeepObj(this.profil, 'pendidikan_instansi') || '-',
            },
            {
              key: 'k_pendidikan_bidang_psp',
              label: 'Bidang Pendidikan Terakhir',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_pendidikan_bidang.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'pendidikan_jurusan',
              label: 'Jurusan',
              value: this.$getDeepObj(this.profil, 'pendidikan_jurusan') || '-',
            },
          ],
        ],
        tambahan: [
          [
            {
              key: 'instansi_nama',
              label: 'Nama Instansi',
              value: this.$getDeepObj(this.profil, 'instansi_nama') || '-',
            },
            {
              key: 'instansi_alamat',
              label: 'Alamat Instansi',
              value: this.$getDeepObj(this.profil, 'instansi_alamat') || '-',
            },
          ],
          [
            {
              key: 'instansi_k_propinsi',
              label: 'Provinsi Bertugas Saat Ini',
              value: this.$getDeepObj(this.profil, 'm_propinsi_instansi.data.keterangan') || '-',
            },
            {
              key: 'instansi_k_kota',
              label: 'Kabupaten/Kota Bertugas Saat Ini',
              value: this.$getDeepObj(this.profil, 'm_kota_instansi.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'instansi_situs',
              label: 'Website Instansi',
              value: this.$getDeepObj(this.profil, 'instansi_situs') || '-',
            },
          ],
        ],
        kurikulum: [
          [
            {
              key: 'k_kurikulum_psp',
              label: 'Jenis Kurikulum',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_kurikulum.data.keterangan') || '-',
            },
          ],
        ],
        pengawas: [
          [
            {
              key: 'k_jenjang_pengawas_psp',
              label: 'Jenjang Satuan Pendidikan Penugasan',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_jenjang_pengawas.data.keterangan') || '-',
            },
          ],
        ],
      };
      const tambahan = this.$getDeepObj(this.profil, 'psp_profil_tambahans.data') || [];
      // const tambahanJenjangLama = tambahan.filter((item) => item.master === 'tambahan_jenjang_lama');
      const tambahanJenjangPrioritas = tambahan.filter((item) => item.master === 'tambahan_jenjang_prioritas');
      const tambahanInstruktur = tambahan.filter((item) => item.master === 'tambahan_instruktur_nasional');

      return {
        dasar: [
          [
            {
              key: 'nama',
              label: 'Nama',
              value: this.$getDeepObj(this.profil, 'ptk.data.nama') || '-',
            },
            {
              key: 'no_ukg',
              label: 'Nomor UKG',
              value: this.$getDeepObj(this.profil, 'ptk.data.no_ukg') || '-',
            },
          ],
          this.isAsesor
            ? ''
            : [
                {
                  key: 'nik',
                  label: 'NIK (sesuai KTP)',
                  value: this.$getDeepObj(this.profil, 'nik') || '-',
                },
              ],
          this.isAsesor
            ? [
                {
                  key: 'nik',
                  label: 'NIK (sesuai KTP)',
                  value: this.$getDeepObj(this.profil, 'nik') || '-',
                },
                {
                  key: 'email',
                  label: 'Surel (untuk Kontak)',
                  value: this.$getDeepObj(this.profil, 'ptk.data.alt_email') || '-',
                },
              ]
            : [
                {
                  key: 'no_wa',
                  label: 'Nomor Telepon (terhubung WhatsApp)',
                  value: this.$getDeepObj(this.profil, 'no_wa') || '-',
                },
                {
                  key: 'email',
                  label: 'Surel (untuk Kontak)',
                  value: this.$getDeepObj(this.profil, 'ptk.data.alt_email') || '-',
                },
              ],
          [
            {
              key: 'tmp_lahir',
              label: 'Tempat Lahir',
              value: this.$getDeepObj(this.profil, 'ptk.data.tmp_lahir') || '-',
            },
            {
              key: 'tgl_lahir',
              label: 'Tanggal Lahir',
              value: this.$localDate(this.$getDeepObj(this.profil, 'ptk.data.tgl_lahir') || '-'),
            },
          ],
          [
            {
              key: 'k_propinsi',
              label: 'Provinsi (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'm_propinsi.data.keterangan') || '-',
            },
            {
              key: 'k_kota',
              label: 'Kota/Kabupaten (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'm_kota.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'alamat',
              label: 'Alamat (sesuai KTP)',
              value: this.$getDeepObj(this.profil, 'alamat') || '-',
              size: 12,
            },
          ],
          [
            {
              key: 'jenjang',
              label: 'Jenjang',
              value: this.$getDeepObj(this.profil, 'ptk.data.ptk_sekolah.data.sekolah.data.m_jenjang.data.singkat'),
            },
          ],
          [
            {
              key: 'k_kasek_lama_psp',
              label: 'Lama menjabat sebagai Kepala Satuan Pendidikan',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_kasek_lama.data.keterangan') || '-',
            },
            {
              key: 'k_kasek_sisa_psp',
              label: 'Sisa masa tugas sebagai kepala satuan pendidikan',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_kasek_sisa.data.keterangan') || '-',
            },
          ],
          [
            {
              key: 'k_pendidikan_psp',
              label: 'Pendidikan terakhir',
              value: this.$getDeepObj(this.profil, 'm_kualifikasi.data.keterangan') || '-',
            },
            {
              key: 'pendidikan_instansi',
              label: 'Nama instansi pendidikan terakhir',
              value: this.$getDeepObj(this.profil, 'pendidikan_instansi') || '-',
            },
          ],
          [
            {
              key: 'k_pendidikan_bidang_psp',
              label: 'Bidang Pendidikan Terakhir',
              value: this.$getDeepObj(this.profil, 'm_profil_opsi_psp_pendidikan_bidang.data.keterangan') || '-',
            },
            {
              key: 'pendidikan_jurusan',
              label: 'Jurusan',
              value: this.$getDeepObj(this.profil, 'pendidikan_jurusan') || '-',
            },
          ],
        ],
        pa: [
          ...schemaPa.dasar,
          ...([2].includes(Number(kUnsurPsp)) ? schemaPa.profesi : []),
          ...([10, 22, 23, 25].includes(Number(kUnsurPsp))
            ? [17099, 17010].includes(kKurikulumPsp)
              ? [].concat(schemaPa.kurikulum, [
                  kKurikulumPsp === 17099
                    ? [
                        {
                          key: 'kurikulum_lain',
                          label: 'Jenis Kurikulum Lain',
                          value: this.$getDeepObj(this.profil, 'kurikulum_lain') || '-',
                        },
                      ]
                    : [
                        {
                          key: 'k_kurikulum_internasional_psp',
                          label: 'K13 Plus Kurikulum Internasional',
                          value:
                            this.$getDeepObj(
                              this.profil,
                              'm_profil_opsi_psp_kurikulum_internasional.data.keterangan'
                            ) || '-',
                        },
                      ],
                ])
              : schemaPa.kurikulum
            : []),
          ...([21].includes(Number(kUnsurPsp)) ? schemaPa.pengawas : []),
          ...schemaPa.tambahan,
          ...schemaPa.pendidikan,
        ],
        tambahan: [
          [
            {
              key: 'instansi_k_kota',
              label:
                'Sebutkan jenjang satuan pendidikan yang menjadi prioritas untuk Bapak/Ibu dampingi jika terpilih sebagai Fasilitator? ',
              value: this.$fkata(
                tambahanJenjangPrioritas.map((item) => this.$getDeepObj(item, 'm_profil_opsi_psp.data.keterangan'))
              ),
            },
          ],
          [
            {
              key: 'instansi_k_propinsi',
              label:
                'Apakah Bapak/Ibu pernah atau sedang bertugas sebagai Instruktur Nasional Program Sekolah Penggerak?',
              value: this.$fkata(
                tambahanInstruktur.map((item) => this.$getDeepObj(item, 'm_profil_opsi_psp.data.keterangan'))
              ),
            },
          ],
        ],
      };
    },

    listBerkases() {
      const berkas = this.$getDeepObj(this.initValue, 'psp_profil_berkases.data') || [];
      return this.isAsesor ? berkas.filter((s) => s.k_profil_berkas_psp !== 5) || [] : berkas;
    },
  },
  methods: {
    onView(item) {
      this.$set(this.preview, 'title', this.$getDeepObj(item, 'm_profil_berkas_psp.data.keterangan'));
      this.$set(this.preview, 'url', this.$getDeepObj(item, 'url_berkas'));

      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },

    getEsai(nomor) {
      const pertanyaan = this.$getDeepObj(this.initValue, 'meta.pertanyaan_esai') || [];
      const esai = pertanyaan.filter((item) => {
        return item.nomor === nomor;
      });
      return esai;
    },

    toLink(url) {
      this.$set(this.preview, 'title', 'Dokumen Satuan Acara Pelatihan');
      this.$set(this.preview, 'url', url);

      this.$nextTick(() => {
        this.$refs.popup.open();
      });
    },
  },
};
</script>
